var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86952 21.2236C13.8019 28.9436 20.0833 35.2172 27.81 39.1451L33.801 33.1417C34.5523 32.3905 35.6231 32.1763 36.565 32.4757C39.607 33.4815 42.889 34.0275 46.2775 34.0275C47.7879 34.0275 49 35.2396 49 36.75V46.2775C49 47.7879 47.7879 49 46.2775 49C20.7146 49 0 28.2866 0 2.72247C0 1.21995 1.21995 0 2.72247 0H12.25C13.7604 0 14.9725 1.21211 14.9725 2.72247C14.9725 6.11098 15.5185 9.39409 16.5243 12.4406C16.8237 13.3769 16.6095 14.4556 15.8583 15.2068L9.86952 21.2247V21.2236Z",
    fill: "#5EB5AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2c5c2e4e6fd0639d0b158ff380f6b5bc.svg";
export { ForwardRef as ReactComponent };